import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Row } from 'reactstrap';
import ReactLoading from 'react-loading';
import { isEmpty } from 'lodash-es';

import AddLotImage from './AddLotImage';
import SortableImageContainer from './SortableImageContainer';
import ImageSizeTestBanner from '../ImageSizeTestBanner';

/**
 * This container represents everything underneath the dropzone. The upload/reorder/delete
 * functionality is still owned by the parent (AddLotDropzone); this component renders straight from
 * the `files` / `lotImages` props it receives.
 */
const AddLotImageContainer = ({
  abortFile,
  addFileError,
  catalogID,
  files,
  handleDeleteFile,
  handleFileComplete,
  isDeletingFile,
  lotData,
  lotImages,
  lotNumber,
  onSortEnd
}) => {
  const houseID = useSelector(state => state.house.houseID);
  const [showWarningBanner, setShowWarningBanner] = useState(false);

  const handleImageSizeCheck = imageCheck => {
    if (imageCheck) {
      setShowWarningBanner(true);
    }
  };

  if (isEmpty(files) && isEmpty(lotImages)) {
    return null;
  }

  if (isDeletingFile) {
    return <ReactLoading className="loading-spinner" type="spin" color="black" />;
  }

  // The default case since arrays start at 0
  let maxSeqNumber = -1;
  const lotImageKeys = Object.keys(lotImages);

  if (lotImageKeys.length > 0) {
    lotImageKeys.sort((a, b) => a - b);
    // If a user uploads additional images - increment from the largest sequence number
    maxSeqNumber = parseInt([...lotImageKeys].pop(), 10);
  }

  const filesWithErrors = files.filter(file => file.hasError);
  const uploadingFiles = files.filter(file => !file.hasError && !file.isComplete);

  // Row with columns for each file
  return (
    <div className="mt-4">
      <Row>
        {/* Needs to be separated due to sequencing for the reorder HOC */}
        {filesWithErrors.map((file, index) => (
          <AddLotImage
            key={index}
            abortFile={abortFile}
            addFileError={addFileError}
            catalogID={catalogID}
            file={file}
            handleDeleteFile={handleDeleteFile}
            handleFileComplete={handleFileComplete}
            houseID={houseID}
            index={index}
            lotNumber={lotNumber}
            maxSeqNumber={maxSeqNumber}
          />
        ))}
      </Row>

      {showWarningBanner && (
        <Row>
          <ImageSizeTestBanner />
        </Row>
      )}

      <SortableImageContainer
        axis="xy"
        handleDeleteFile={handleDeleteFile}
        lotImages={lotImages}
        lotImageKeys={lotImageKeys}
        maxSeqNumber={maxSeqNumber}
        onSortEnd={onSortEnd}
      />

      <Row>
        {lotData &&
          uploadingFiles.map((file, index) => (
            <AddLotImage
              abortFile={abortFile}
              addFileError={addFileError}
              catalogID={catalogID}
              file={file}
              handleDeleteFile={handleDeleteFile}
              handleFileComplete={handleFileComplete}
              houseID={houseID}
              index={index}
              key={index}
              lotNumber={lotNumber}
              maxSeqNumber={maxSeqNumber}
              lotData={lotData}
              handleImageSizeCheck={handleImageSizeCheck}
            />
          ))}
      </Row>
    </div>
  );
};

export default AddLotImageContainer;
